export default {
  data () {
    let version = location.pathname.match(/planbkTemplatev(\d+).html/)
    version = version && version[1]
    return {
      RESULT_VERSION: Number(version) || 1
    }
  }
}